import React, { Fragment } from 'react'
import './style.css'

export default function ServiceSystem(props) {
    return(
        <div className='Home_SpaceBasedPlan'>
            <div className='Home_SpaceBasedPlan_MainTitle'>共性应用支撑服务系统</div>
            <div className='Home_SpaceBasedPlan_FirstMain'>
                <div className='Home_SpaceBasedPlan_MainIntroduceText'>共性应用技术支撑服务系统实现了一站式的共性技术服务，提供长期、持续、稳定的共性技术研发支撑基础性共性服务，促进应用共性技术创新发展与开放共享，提升国家资源高效利用程度，支撑“一星多用、多星组网、多网协同、多星共用、数据集成”局面的实现。系统通过构建多模式的综合服务体系，形成了网络化资源共享与服务协同应用门户、多源遥感数据集群处理系统、专业化桌面软件和实地遥感即时服务移动APP，具备空基卫星实验验证与仿真分析能力、地面真值采集与处理能力、共性产品检验与定制能力、共性技术评测与共享支撑能力、空基应用技术资源综合共享服务能力。</div>
            </div>
            <div className='Home_SpaceBasedPlan_Imgs3'>
                <img className='Home_SpaceBasedPlan_Img_ServiceSystem' src="images/Introduce/ServiceSystem/1.png" />
                <img className='Home_SpaceBasedPlan_Img_ServiceSystem' src="images/Introduce/ServiceSystem/2.png" />
            </div>
        </div>
    )
}